module.exports = __webpack_public_path__ + "img/0Q3A6289_L_Wood.45c807b3.jpg";